import { createContext, useContext } from 'react';
import type { Theme, ThemePreference } from '@/shared/lib/theme';

export interface ThemeContextValue {
  /** Ustawienie uzytkownika: `light`, `dark` albo `system`. */
  preference: ThemePreference;
  /** Motyw faktycznie widoczny na ekranie. */
  theme: Theme;
  setPreference: (preference: ThemePreference) => void;
  /** Przelacza miedzy jasnym a ciemnym, zapisujac jawny wybor. */
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

/** Dostep do motywu. Rzuca wyjatek poza `ThemeProvider` — to blad programisty. */
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme musi być użyte wewnątrz ThemeProvider.');
  }
  return context;
}
